import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import type { ReactNode } from "react";

import { loadCount } from "../../slice";
import { selectCount } from "../../selector";
import type { AppointmentCount } from "../../types";
import {
  StatCard,
  StatIconCircle,
  StatLabel,
  StatsGrid,
  StatTopRow,
  StatValue,
} from "../../style";

interface StatDef {
  key: keyof AppointmentCount;
  icon: ReactNode;
  label: string;
}

const statDefs: StatDef[] = [
  {
    key: "total_appointments",
    icon: <CalendarOutlined />,
    label: "Total Appointments",
  },
  {
    key: "scheduled_appointments",
    icon: <ScheduleOutlined />,
    label: "Scheduled Appointments",
  },
  {
    key: "unsuccessful_appointments",
    icon: <ExclamationCircleOutlined />,
    label: "Unsuccessful Appointments",
  },
  {
    key: "cancelled_appointments",
    icon: <CloseCircleOutlined />,
    label: "Cancelled Appointments",
  },
];

export default function StatsRow() {
  const dispatch = useDispatch();
  const { data } = useSelector(selectCount);

  useEffect(() => {
    dispatch(loadCount());
  }, [dispatch]);

  return (
    <StatsGrid gap={14} wrap="wrap">
      {statDefs.map((s) => (
        <StatCard key={s.key}>
          <StatTopRow align="center" justify="space-between">
            <StatIconCircle align="center" justify="center">
              {s.icon}
            </StatIconCircle>
          </StatTopRow>
          <StatLabel>{s.label}</StatLabel>
          <StatValue level={3}>{data?.[s.key] ?? 0}</StatValue>
        </StatCard>
      ))}
    </StatsGrid>
  );
}
